'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ../~/markdown-it/index.js
// module id = 305
// module chunks = 0